import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useChat } from '../../hooks/useChat';
import { UserSearch } from './UserSearch';
import { ChatUser } from '../../types/chat.types'; // <--- Імпортуємо новий, спрощений тип
import { BaseDialog } from '../common/BaseDialog.tsx';

type UseChatReturn = ReturnType<typeof useChat>;

export const CreateConversationDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  chat: UseChatReturn;
}> = ({ open, onClose, chat }) => {
  // Тепер стан зберігає об'єкт типу ChatUser
  const [selectedUser, setSelectedUser] = useState<ChatUser | null>(null);
  const { openConversationWithUser } = chat;

  const handleCreate = async () => {
    if (!selectedUser) return;

    try {
      // Для створення бесіди, як і раніше, використовуємо ID
      await openConversationWithUser(selectedUser.id);
      setSelectedUser(null);
      onClose();
    } catch (error) {
      console.error('Помилка створення розмови:', error);
    }
  };

  const handleClose = () => {
    setSelectedUser(null);
    onClose();
  };

  const dialogActions = (
    <>
      <Button onClick={handleClose}>Скасувати</Button>
      <Button 
        onClick={handleCreate} 
        variant="contained" 
        disabled={!selectedUser}
      >
        Створити
      </Button>
    </>
  );

  return (
    <BaseDialog
      open={open}
      onClose={handleClose}
      title="Нова розмова"
      actions={dialogActions}
    >
      <UserSearch onUserSelect={setSelectedUser} />
    </BaseDialog>
  );
};